export const RESULT_SUCCESS = 'RESULT_SUCCESS'
export const RESULT_ERROR = 'RESULT_ERROR'
export const RESULT_WARNING = 'RESULT_WARNING'